import { Injectable } from '@angular/core';

Injectable()
export class Config {
    public readonly IS_AUTHENTICATED: boolean = false;
}